import { render, staticRenderFns } from "./ListOldTutoring.vue?vue&type=template&id=6024cb9b"
import script from "./ListOldTutoring.vue?vue&type=script&lang=js"
export * from "./ListOldTutoring.vue?vue&type=script&lang=js"
import style0 from "./ListOldTutoring.vue?vue&type=style&index=0&id=6024cb9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports